<template>
  <v-dialog
    v-model="dialog"
    width="700"
    scrollable
  >
    <v-card>
      <v-card-title class="py-2 px-4">
        Seleccionar porcentajes
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="dialog = false"
        >
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card
          v-for="(region, index) of pais"
          :key="index"
          outlined
          flat
        >
          <v-row class="justify-end" no-gutters>
            <v-col :cols="region.canales.length == 0 ? 12 : 2" class="d-flex align-center">
              <span class="pl-2">
                {{ region.nombre }}
              </span>
              <template v-if="region.canales.length == 0">
                <v-spacer></v-spacer>
                <v-btn
                  v-if="region.locales.length > 0"
                  color="error"
                  title="Quitar todos los locales"
                  small
                  icon
                  @click="region.por_local = 0; region.locales = []"
                >
                  <v-icon small>fas fa-angle-double-up</v-icon>
                </v-btn>
                <v-btn
                  color="success"
                  title="Agregar todos los locales"
                  small
                  icon
                  @click="agregarTodos(region, region.id)"
                >
                  <v-icon small>fas fa-angle-double-down</v-icon>
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-2"
                  title="Agregar local"
                  small
                  icon
                  @click="agregarLocal(region)"
                >
                  <v-icon small>fas fa-plus</v-icon>
                </v-btn>
                <div style="width: 20%;">
                  <v-text-field
                    v-model="region.porcentaje"
                    type="number"
                    suffix="%"
                    hide-details
                    outlined
                    dense
                    @change="recalcularPorc(1, region)"
                  ></v-text-field>
                </div>
                <v-icon
                  v-if="roundNumberTF(total, 4) != 100"
                  title="Imputar diferencia"
                  color="success"
                  class="mx-2"
                  small
                  @click="imputar(region)"
                >
                  fas fa-arrow-left
                </v-icon>
              </template>
              </v-col>
                <DesagregosPorcLoc
                :padre="region"
                :empresa="empresa"
                :region="region.id"
                @recalcularPorc="recalcularPorc"
                @imputar="imputar"
                @quitar="quitar"
              />
            <v-col v-if="region.canales.length > 0" cols="10">
              <v-card
                v-for="(canal, index) of region.canales"
                :key="index"
                outlined
                flat
              >
                <v-row class="justify-end" no-gutters>
                  <v-col cols="12" class="d-flex align-center">
                    <span class="pl-2">
                      {{ canal.nombre }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="canal.locales.length > 0"
                      color="error"
                      title="Quitar todos los locales"
                      small
                      icon
                      @click="canal.por_local = 0; canal.locales = []"
                    >
                      <v-icon small>fas fa-angle-double-up</v-icon>
                    </v-btn>
                    <v-btn
                      color="success"
                      title="Agregar todos los locales"
                      small
                      icon
                      @click="agregarTodos(canal, region.id, canal.id)"
                    >
                      <v-icon small>fas fa-angle-double-down</v-icon>
                    </v-btn>
                    <v-btn
                      color="success"
                      class="mr-2"
                      title="Agregar local"
                      small
                      icon
                      @click="agregarLocal(canal)"
                    >
                      <v-icon small>fas fa-plus</v-icon>
                    </v-btn>
                    <div style="width: 20%;">
                      <v-text-field
                        v-model="canal.porcentaje"
                        type="number"
                        suffix="%"
                        hide-details
                        outlined
                        dense
                        @change="recalcularPorc(2, canal)"
                      ></v-text-field>
                    </div>
                    <v-icon
                      v-if="roundNumberTF(total, 4) != 100"
                      title="Imputar diferencia"
                      color="success"
                      class="mx-2"
                      small
                      @click="imputar(canal)"
                    >
                      fas fa-arrow-left
                    </v-icon>
                  </v-col>
                  <DesagregosPorcLoc
                    :padre="canal"
                    :empresa="empresa"
                    :region="region.id"
                    :canal="canal.id"
                    @recalcularPorc="recalcularPorc"
                    @imputar="imputar"
                    @quitar="quitar"
                  />
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <div class="d-flex pt-2 body-1 font-weight-bold">
          Total
          <v-spacer></v-spacer>
          {{ total }} %
        </div>
        <div v-if="roundNumberTF(total, 4) != 100" class="d-flex px-2" style="font-size: 12px;">
          <v-spacer></v-spacer>
          ({{ roundNumberTF(100 - total, 4) }} %)
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          color="orange"
          small
          dark
          @click="dialog = false"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="indigo"
          small
          dark
          @click="confirmar()"
        >
          <v-icon left>fas fa-check</v-icon>
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { roundNumberTF } from '../../util/utils'
import DesagregosPorcLoc from './DesagregosPorcLoc.vue'

export default {
  data () {
    return {
      roundNumberTF: roundNumberTF,
      total: 0,
      pais: []
    }
  },
  props: {
    value: Boolean,
    importe: Number,
    periodo: String,
    empresa: Number,
    region: Array,
    canal: Array,
    meses: String
  },
  computed: {
    ...mapState(['all_locales']),
    dialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    DesagregosPorcLoc
  },
  watch: {
    dialog (val) {
      if (val) {
        for (const region of this.region) {
          this.pais.push({
            id: region.codigo,
            nombre: region.nombre,
            canales: [],
            locales: [],
            porcentaje: null,
            modificado: 0,
            por_local: 0
          })
        }
        for (const canal of this.canal) {
          for (let region of this.pais) {
            region.canales.push({
              id: canal.id,
              nombre: canal.nombre,
              locales: [],
              porcentaje: null,
              modificado: 0,
              por_local: 0
            })
          }
        }
        if (this.canal.length == 0) {
          this.distribuirRegiones()
        } else {
          this.distribuirCanales()
        }
      } else {
        this.total = 0
        this.pais = []
      }
    }
  },
  methods: {
    confirmar () {
      if (this.total != 100) {
        this.$store.dispatch('show_snackbar', {
          text: 'El % total debe ser 100',
          color: 'orange'
        })
        return
      }
      for (const region of this.pais) {
        if (roundNumberTF(region.locales.reduce((sum, rl) => sum + roundNumberTF(rl.porcentaje, 4), 0), 4) > 100) {
          this.$store.dispatch('show_snackbar', {
            text: `El % total de ${region.nombre} no debe superar 100`,
            color: 'orange'
          })
          return
        }
        for (const canal of region.canales) {
          if (roundNumberTF(canal.locales.reduce((sum, cl) => sum + roundNumberTF(cl.porcentaje, 4), 0), 4) > 100) {
            this.$store.dispatch('show_snackbar', {
                text: `El % total de ${canal.nombre} de ${region.nombre} no debe superar 100`,
                color: 'orange'
              })
              return
          }
        }
      }
      
      let data = []
      if (this.canal.length == 0) {
        for (const region of this.pais) {
          this.calcularDistribucion(data, region, region.id)
        }
      } else {
        for (const region of this.pais) {
          for (const canal of region.canales) {
            this.calcularDistribucion(data, canal, region.id, canal.id)
          }
        }
      }
      this.$emit('confirmar', data)
      this.dialog = false
    },
    calcularDistribucion (data, item, region_id, canal_id) {
      const meses = parseInt(this.meses)
      const porcentaje = roundNumberTF(item.porcentaje, 4)
      
      if (porcentaje > 0) {
        for (let local of item.locales) {
          let porcentaje_local = roundNumberTF(local.porcentaje, 4)
          let porcentaje_final = roundNumberTF((porcentaje_local * porcentaje) / 10000, 4)
          
          const importe = roundNumberTF(this.importe * porcentaje_final)
          data.push({
            id: 0,
            periodo: `01/${this.periodo}`,
            local_id: local.local,
            local_nombre: this.all_locales.find(al => al.id == local.local).nombre,
            porcentaje: roundNumberTF(porcentaje_final * 100, 4),
            importe_mensual: roundNumberTF(importe / meses),
            importe: importe,
            meses: meses
          })
        }
        
        let porcentaje_dedicado = roundNumberTF(item.locales.reduce((sum, cl) => sum + roundNumberTF(cl.porcentaje, 4), 0), 4)
        let porcentaje_restante = 100 - porcentaje_dedicado
        if (porcentaje_restante != 0) {
          let locales = this.all_locales.filter(al => al.empresa == this.empresa && al.region_id == region_id && (al.canal == canal_id || canal_id == undefined) &&
                                                      !item.locales.map(cl => cl.local).includes(al.id))
          let porcentaje_distribuir = roundNumberTF((porcentaje * porcentaje_restante) / locales.length, 4)

          for (const local of locales) {
            let porcentaje_final = roundNumberTF(porcentaje_distribuir / 10000, 4)

            const importe = roundNumberTF(this.importe * porcentaje_final)
            data.push({
              id: 0,
              periodo: `01/${this.periodo}`,
              local_id: local.id,
              local_nombre: local.nombre,
              porcentaje: roundNumberTF(porcentaje_final * 100, 4),
              importe_mensual: roundNumberTF(importe / meses),
              importe: importe,
              meses: meses
            })
          }
        }
      }
    },
    recalcularPorc (profundidad, item, locales) {
      item.modificado = 1
      switch (profundidad) {
        case 1:
          this.distribuirRegiones()
          break
        case 2:
          this.distribuirCanales()
          break
        case 3:
          this.distribuirLocales(locales)
          break
      }
    },
    distribuirRegiones () {
      let array = this.pais.filter(p => p.modificado == 1)
      let cantidad_modificar = this.pais.length - array.length
      let porcentaje_actual = roundNumberTF(array.reduce((sum, arr) => sum + roundNumberTF(arr.porcentaje, 4), 0), 4)
      let porcentaje_distribuir = roundNumberTF((100 - porcentaje_actual) / cantidad_modificar, 4)
      for (let region of this.pais.filter(p => p.modificado == 0)) {
        region.porcentaje = porcentaje_distribuir > 0 ? porcentaje_distribuir : 0
      }
      this.total = roundNumberTF(this.pais.reduce((sum, p) => sum + roundNumberTF(p.porcentaje, 4), 0), 4)
    },
    distribuirCanales () {
      let array = []
      let cantidad_modificar = 0
      let porcentaje_actual = 0
      let porcentaje_distribuir = 0
      for (let region of this.pais) {
        array = region.canales.filter(pr => pr.modificado == 1)
        cantidad_modificar += region.canales.length - array.length
        porcentaje_actual += roundNumberTF(array.reduce((sum, arr) => sum + roundNumberTF(arr.porcentaje, 4), 0), 4)
      }
      porcentaje_distribuir = roundNumberTF((100 - porcentaje_actual) / cantidad_modificar, 4)
      let total = 0
      for (let region of this.pais) {
        for (let canal of region.canales.filter(rc => rc.modificado == 0)) {
          canal.porcentaje = porcentaje_distribuir > 0 ? porcentaje_distribuir : 0
        }
        total += roundNumberTF(region.canales.reduce((sum, rc) => sum + roundNumberTF(rc.porcentaje, 4), 0), 4)
      }
      this.total = roundNumberTF(total, 4)
    },
    distribuirLocales (locales) {
      let array = locales.filter(cl => cl.modificado == 1)
      let cantidad_modificar = locales.length - array.length
      let porcentaje_actual = roundNumberTF(array.reduce((sum, arr) => sum + roundNumberTF(arr.porcentaje, 4), 0), 4)
      let porcentaje_distribuir = roundNumberTF((100 - porcentaje_actual) / cantidad_modificar, 4)
      for (let local of locales.filter(cl => cl.modificado == 0)) {
        local.porcentaje = porcentaje_distribuir > 0 ? porcentaje_distribuir : 0
      }
    },
    agregarTodos (item, region_id, canal_id) {
      if (item.locales.find(cl => !cl.local)) {
        this.$store.dispatch('show_snackbar', {
          text: 'Complete el local anterior antes de agregar todos',
          color: 'orange'
        })
        return
      }
      item.por_local = 1
      for (const local of this.all_locales.filter(al => al.empresa == this.empresa && al.region_id == region_id && (al.canal == canal_id || canal_id == undefined))) {
        let existe = item.locales.find(cl => cl.local == local.id)
        if (!existe) {
          item.locales.push({
            local: local.id,
            porcentaje: null,
            modificado: 0
          })
        }
      }
      this.distribuirLocales(item.locales)
    },
    agregarLocal (item) {
      if (item.locales.find(cl => !cl.local)) {
        this.$store.dispatch('show_snackbar', {
          text: 'Complete el local anterior antes de agregar otro',
          color: 'orange'
        })
        return
      }
      
      item.por_local = 1
      item.locales.push({
        local: null,
        porcentaje: null,
        modificado: 0
      })

      if (item.locales.length == 1) {
        item.locales[0].porcentaje = 100
      } else {
        this.distribuirLocales(item.locales)
      }
    },
    quitar (item, locales) {
      const index = locales.indexOf(item)
      locales.splice(index, 1)
      this.distribuirLocales(locales)
    },
    imputar (item, locales) {
      if (locales) {
        item.porcentaje = roundNumberTF(parseFloat(item.porcentaje) + (100 - locales.reduce((sum, l) => sum + roundNumberTF(l.porcentaje, 4), 0)), 4)
      } else {
        item.porcentaje = roundNumberTF(parseFloat(item.porcentaje) + (100 - this.total), 4)
        this.total = 100
      }
    }
  }
}
</script>